export const modulesOperations = {
    apiModulesList: {
        query: {
            meta: {
                localeAware: true,
            },
            options: {
                retry: false,
                staleTime: Infinity,
                cacheTime: Infinity,
                keepPreviousData: true,
            },
        },
    },
    apiModulesDropdownList: {
        query: {
            meta: {
                localeAware: true,
            },
            options: {
                retry: false,
                staleTime: Infinity,
                cacheTime: Infinity,
                keepPreviousData: true,
            },
        },
    },
};
